import _toConsumableArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectDestructuringEmpty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import { AmericanCountryList, EuropeanUnionList, PROVIDER_SOURCE, UKCountryList, formatCurrency, getDeductionMethodMap, sortTheCoveragesOrder, useQuotePriceDetailInfo } from '@jove-frontend/uikit';
import { Box } from '@mui/material';
import { AnnualPaymentCompareItem, GeographicCompareItem, InsurerCompareItem, MonthlyPaymentCompareItem, ProductCompareItem, TotalPaymentCompareItem } from './compareItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PriceComparisonPolicyCompareList = function PriceComparisonPolicyCompareList(props) {
  var _info$jove_quote_pric, _allData$insurer, _allData$insurer2, _info$jove_quote_pric2, _info$jove_quote_pric3, _allData$products, _allData$products2, _allData$geographic, _allData$geographic2, _allData$monthlyPayme, _allData$monthlyPayme2, _allData$monthlyPayme3, _allData$monthlyPayme4, _allData$monthlyPayme5, _allData$monthlyPayme6, _allData$annualPremiu, _allData$annualPremiu2, _allData$annualPaymen, _allData$annualPaymen2;

  var info = props.info,
      valueChange = props.valueChange,
      defaultCountry = props.defaultCountry,
      disableSwitchCountry = props.disableSwitchCountry,
      hideCountry = props.hideCountry;

  var _useState = useState(null),
      allData = _useState[0],
      setAllData = _useState[1];

  var _useQuotePriceDetailI = useQuotePriceDetailInfo(),
      generateQuotePriceSummaryInfoList = _useQuotePriceDetailI.generateQuotePriceSummaryInfoList,
      generateQuotePriceCurrentPayInfo = _useQuotePriceDetailI.generateQuotePriceCurrentPayInfo;
  /**
   * effects
   */


  useEffect(function () {
    if (info) {
      var _ref = (info === null || info === void 0 ? void 0 : info.comparison) || {},
          insurer_name = _ref.insurer_name,
          products = _ref.products,
          geographic_limitation = _ref.geographic_limitation,
          policyMonthlyPremiumText = _ref.policyMonthlyPremiumText,
          policyAnnualPremiumText = _ref.policyAnnualPremiumText,
          annualSavingText = _ref.annualSavingText,
          savingPercentage = _ref.savingPercentage,
          policyAnnualTotalText = _ref.policyAnnualTotalText;

      var _ref2 = (info === null || info === void 0 ? void 0 : info.jove_quote_price) || {};

      _objectDestructuringEmpty(_ref2);

      var newCoverageList = generateQuotePriceSummaryInfoList(info === null || info === void 0 ? void 0 : info.jove_quote_price);
      newCoverageList = sortTheCoveragesOrder(newCoverageList, {
        orderKey: 'key'
      });
      var originCoverageList = sortTheCoveragesOrder(products || [], {
        orderKey: 'key'
      });
      var newQuotePayPriceInfo = generateQuotePriceCurrentPayInfo(info === null || info === void 0 ? void 0 : info.jove_quote_price);
      setAllData({
        insurer: {
          left: insurer_name,
          right: 'Jove'
        },
        products: {
          left: originCoverageList.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              coverageText: "Liability coverage level:: ".concat(formatCurrency({
                amount: (item === null || item === void 0 ? void 0 : item.amount) || 0,
                currency: item === null || item === void 0 ? void 0 : item.currency
              })),
              key: item.cover_slug
            });
          }),
          right: newCoverageList.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              coverageText: "Liability coverage level: ".concat(item.coverageText)
            });
          })
        },
        geographic: {
          left: geographic_limitation,
          right: 'Worldwide including USA and Canada'
        },
        monthlyPayment: {
          left: policyMonthlyPremiumText,
          right: newQuotePayPriceInfo === null || newQuotePayPriceInfo === void 0 ? void 0 : newQuotePayPriceInfo.monthlySchedulePayText,
          rightDownPayment: newQuotePayPriceInfo === null || newQuotePayPriceInfo === void 0 ? void 0 : newQuotePayPriceInfo.monthlyCurrentPayText,
          rightNote: 'Including IPT and admin fee',
          discountAmount: annualSavingText,
          discountPercentage: "".concat(savingPercentage, "%")
        },
        annualPayment: {
          left: policyAnnualTotalText,
          right: newQuotePayPriceInfo === null || newQuotePayPriceInfo === void 0 ? void 0 : newQuotePayPriceInfo.annualCurrentPayText
        },
        annualPremiumPayment: {
          left: policyAnnualPremiumText,
          right: newQuotePayPriceInfo === null || newQuotePayPriceInfo === void 0 ? void 0 : newQuotePayPriceInfo.currentPayPremiumText
        }
      });
    }
  }, [info]);
  /**
   * methods
   */

  var countryChangeAction = function countryChangeAction(value) {
    valueChange === null || valueChange === void 0 ? void 0 : valueChange({
      country: value,
      businessCountry: value
    });
  };

  var isMonthly = (info === null || info === void 0 ? void 0 : (_info$jove_quote_pric = info.jove_quote_price) === null || _info$jove_quote_pric === void 0 ? void 0 : _info$jove_quote_pric.billing_cycle) === getDeductionMethodMap().monthly.value;
  return /*#__PURE__*/_jsxs(Box, {
    className: "flex flex-col",
    children: [/*#__PURE__*/_jsx(InsurerCompareItem, {
      leftInsurer: allData === null || allData === void 0 ? void 0 : (_allData$insurer = allData.insurer) === null || _allData$insurer === void 0 ? void 0 : _allData$insurer.left,
      rightInsurer: allData === null || allData === void 0 ? void 0 : (_allData$insurer2 = allData.insurer) === null || _allData$insurer2 === void 0 ? void 0 : _allData$insurer2.right,
      valueChange: countryChangeAction,
      defaultCountry: defaultCountry,
      disableSwitchCountry: disableSwitchCountry || [PROVIDER_SOURCE().GREATEAMERICAN.value].includes(info === null || info === void 0 ? void 0 : (_info$jove_quote_pric2 = info.jove_quote_price) === null || _info$jove_quote_pric2 === void 0 ? void 0 : _info$jove_quote_pric2.provider_code),
      hideCountry: hideCountry,
      allowSelectCountryList: [PROVIDER_SOURCE().GREATEAMERICAN.value].includes(info === null || info === void 0 ? void 0 : (_info$jove_quote_pric3 = info.jove_quote_price) === null || _info$jove_quote_pric3 === void 0 ? void 0 : _info$jove_quote_pric3.provider_code) ? _toConsumableArray(AmericanCountryList) : [].concat(_toConsumableArray(UKCountryList), _toConsumableArray(EuropeanUnionList))
    }), /*#__PURE__*/_jsx(Box, {
      className: "h-px bg-white"
    }), /*#__PURE__*/_jsx(ProductCompareItem, {
      leftProducts: allData === null || allData === void 0 ? void 0 : (_allData$products = allData.products) === null || _allData$products === void 0 ? void 0 : _allData$products.left,
      rightProducts: allData === null || allData === void 0 ? void 0 : (_allData$products2 = allData.products) === null || _allData$products2 === void 0 ? void 0 : _allData$products2.right
    }), /*#__PURE__*/_jsx(Box, {
      className: "h-px bg-white"
    }), /*#__PURE__*/_jsx(GeographicCompareItem, {
      leftRegion: allData === null || allData === void 0 ? void 0 : (_allData$geographic = allData.geographic) === null || _allData$geographic === void 0 ? void 0 : _allData$geographic.left,
      rightRegion: allData === null || allData === void 0 ? void 0 : (_allData$geographic2 = allData.geographic) === null || _allData$geographic2 === void 0 ? void 0 : _allData$geographic2.right
    }), /*#__PURE__*/_jsx(Box, {
      className: "h-px bg-white"
    }), isMonthly ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(MonthlyPaymentCompareItem, {
        leftAmount: allData === null || allData === void 0 ? void 0 : (_allData$monthlyPayme = allData.monthlyPayment) === null || _allData$monthlyPayme === void 0 ? void 0 : _allData$monthlyPayme.left,
        rightAmount: allData === null || allData === void 0 ? void 0 : (_allData$monthlyPayme2 = allData.monthlyPayment) === null || _allData$monthlyPayme2 === void 0 ? void 0 : _allData$monthlyPayme2.right,
        rightDownPayment: allData === null || allData === void 0 ? void 0 : (_allData$monthlyPayme3 = allData.monthlyPayment) === null || _allData$monthlyPayme3 === void 0 ? void 0 : _allData$monthlyPayme3.rightDownPayment,
        rightNote: allData === null || allData === void 0 ? void 0 : (_allData$monthlyPayme4 = allData.monthlyPayment) === null || _allData$monthlyPayme4 === void 0 ? void 0 : _allData$monthlyPayme4.rightNote,
        discountAmount: allData === null || allData === void 0 ? void 0 : (_allData$monthlyPayme5 = allData.monthlyPayment) === null || _allData$monthlyPayme5 === void 0 ? void 0 : _allData$monthlyPayme5.discountAmount,
        discountPercentage: allData === null || allData === void 0 ? void 0 : (_allData$monthlyPayme6 = allData.monthlyPayment) === null || _allData$monthlyPayme6 === void 0 ? void 0 : _allData$monthlyPayme6.discountPercentage
      }), /*#__PURE__*/_jsx(Box, {
        className: "h-px bg-white"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(AnnualPaymentCompareItem, {
        leftAmount: allData === null || allData === void 0 ? void 0 : (_allData$annualPremiu = allData.annualPremiumPayment) === null || _allData$annualPremiu === void 0 ? void 0 : _allData$annualPremiu.left,
        rightAmount: allData === null || allData === void 0 ? void 0 : (_allData$annualPremiu2 = allData.annualPremiumPayment) === null || _allData$annualPremiu2 === void 0 ? void 0 : _allData$annualPremiu2.right
      }), /*#__PURE__*/_jsx(Box, {
        className: "h-px bg-white"
      })]
    }), /*#__PURE__*/_jsx(TotalPaymentCompareItem, {
      leftAmount: allData === null || allData === void 0 ? void 0 : (_allData$annualPaymen = allData.annualPayment) === null || _allData$annualPaymen === void 0 ? void 0 : _allData$annualPaymen.left,
      rightAmount: allData === null || allData === void 0 ? void 0 : (_allData$annualPaymen2 = allData.annualPayment) === null || _allData$annualPaymen2 === void 0 ? void 0 : _allData$annualPaymen2.right
    })]
  });
};
export default PriceComparisonPolicyCompareList;